module.exports = __webpack_public_path__ + "static/tmp-invoice-3-adfe5e41bbd748588e3f5696293f36de.png";